import type { CommandAction } from '../../CommandPalette'
import type { BuildCommandActionsContext } from './types'

export const buildNavigationShopActions = (
  { t, setSection }: BuildCommandActionsContext,
): CommandAction[] => [
  {
    id: 'nav-shop-products',
    name: t('command.nav.shopProducts'),
    keywords: 'shop ecommerce catalogo prodotti',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.shopProducts.subtitle'),
    perform: () => setSection('shop-products'),
  },
  {
    id: 'nav-shop-categories',
    name: t('command.nav.shopCategories'),
    keywords: 'shop ecommerce categorie tassonomia',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.shopCategories.subtitle'),
    perform: () => setSection('shop-categories'),
  },
  {
    id: 'nav-shop-orders',
    name: t('command.nav.shopOrders'),
    keywords: 'shop ecommerce ordini spedizioni stato',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.shopOrders.subtitle'),
    perform: () => setSection('shop-orders'),
  },
  {
    id: 'nav-shop-customers',
    name: t('command.nav.shopCustomers'),
    keywords: 'clienti customer anagrafica storico ordini',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.shopCustomers.subtitle'),
    perform: () => setSection('customers'),
  },
  {
    id: 'nav-shop-migrations',
    name: t('command.nav.shopMigrations'),
    keywords: 'shop import export zip migrazioni',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.shopMigrations.subtitle'),
    perform: () => setSection('shop-migrations'),
  },
  {
    id: 'nav-shop-product-types',
    name: t('command.nav.shopProductTypes'),
    keywords: 'shop product type studio custom tipologie zip',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.shopProductTypes.subtitle'),
    perform: () => setSection('shop-product-types'),
  },
  {
    id: 'nav-plugins',
    name: t('command.nav.plugins'),
    keywords: 'plugin estensioni blocchi',
    group: t('command.group.navigation'),
    subtitle: t('command.nav.plugins.subtitle'),
    perform: () => setSection('plugins'),
  },
]
